export const GOOGLE_OAUTH_NAME = 'google_oauth2';
export const AUTH_FIELD_MISSED_TERMS = 'terms_acceptance';
export const AUTH_FIELD_MISSED_COUNTRY = 'country';
export const IS_GOOGLE_AUTH_HIDDEN = false;
